import { useQuery } from '@tanstack/react-query';

import { getProductDocumentsByLinkId } from 'services/product';

export const getKeySdsDataSheet = (productId, linkId) => {
  return ['get-sds-data-sheet', productId, linkId];
};

export const useGetSdsDataSheet = ({ productId, linkId }) =>
  useQuery({
    queryKey: getKeySdsDataSheet(productId, linkId),
    queryFn: async () => {
      const response = await getProductDocumentsByLinkId({
        productId,
        linkId,
      });

      if (response?.isSuccess) {
        return response?.data?.gridData?.[0];
      }

      return null;
    },
    enabled: Boolean(productId && linkId),
    refetchOnWindowFocus: false,
  });
